'use strict';

window.FILTERS_DIAS = [
  {id: 0, quantidade: 7},
  {id: 1, quantidade: 15},
  {id: 2, quantidade: 20},
  {id: 3, quantidade: 30},
  {id: 4, quantidade: 40},
  {id: 5, quantidade: 60},
  {id: 5, quantidade: 90},
  {id: 6, quantidade: 120}
];

angular.module('webAgro1App').controller('VisitasWidgetCtrl', function($scope, $rootScope, $http, $timeout, config) {
  $scope.baseId = new Date().getTime();

  var getData = function() {
    $scope.loader = true;
    $scope.error = false;
    var params = {
      dias: config.dias.quantidade,
      propriedade: (config.propriedade || []).map(function(propriedade) {
        return propriedade.id;
      }).join(',') || -1
    };
    $http.get(SERVER + 'v1/dashboard/glebas_visitadas', {params: params}).then(function(result) {
      $scope.data = result.data;
      $scope.drawChart(result.data);
    }, function() {
      $scope.error = true;
    }).finally(function() {
      $scope.loader = false;
    });
  };

  var populateFilters = function() {
    $rootScope.initialize.then(function(result) {
      config.propriedades = result.propriedades.map(function(propriedade) {
        return {
          id: propriedade.id,
          descricao: propriedade.descricao
        };
      });
    });
  };

  var init = function() {
    config.filterDias = FILTERS_DIAS;
    getData();
    populateFilters();
  };
  init();

  $scope.drawChart = function(data) {
    $timeout(function() {
      Object.keys(data).forEach(function(propriedadeId) {
        var ctx = document.getElementById($scope.baseId + '-' + propriedadeId);

        var dataChart = {
          labels: ['Visitadas', 'Não visitadas'],
          datasets: [{
            data: [(data[propriedadeId].visitadas || []).length, (data[propriedadeId].nao_visitadas || []).length],
            backgroundColor: ['#f27548', '#e3eaf2']
          }]
        };

        var options = {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: data[propriedadeId].descricao
          },
          scales: {
            yAxes: [{
              display:false
            }],
            xAxes: [{
              display:false
            }]
          }
        };

        new Chart(ctx, {
          type: 'doughnut',
          data: dataChart,
          options: options
        });
      });
    });
  };
});
